import * as React from 'react';

import { VALID_DIMENSION_DATA, VALID_EDGE_STYLE_DATA, VALID_MEDIA_STYLES, VALID_SHADOW_DATA } from '../Utils';

import StyledBox from './StyledBox';
import { IBoxCommonProps, PositionType } from './common';

export interface IBoxProps extends IBoxCommonProps, React.HTMLAttributes<HTMLDivElement> {
  direction?: VALID_MEDIA_STYLES;
  display?: VALID_MEDIA_STYLES;

  /** @deprecated Use boxShadow instead */
  elevation?: VALID_SHADOW_DATA;
  // tslint:disable-next-line:no-any
  forwardedAs?: keyof JSX.IntrinsicElements | React.ComponentType<any>;
  height?: VALID_DIMENSION_DATA;
  margin?: VALID_EDGE_STYLE_DATA;
  order?: string;
  overflow?: string;
  padding?: VALID_EDGE_STYLE_DATA;
  position?: PositionType;
  transform?: string;
  width?: VALID_DIMENSION_DATA;
}

export const Box = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement> & IBoxProps>((
  props, ref
) => {
  const {
    alignItems,
    alignContent,
    alignSelf,
    backgroundColor,
    border,
    children,
    childrenStyles,
    flexBasis,
    flexGrow,
    flexShrink,
    flexWrap,
    forwardedAs,
    justifyContent,
    /* tslint:disable-next-line deprecation */
    round,
    borderRadius,
    /* properties below are munged to avoid styled-components writing them to the DOM */
    direction,
    display,
    /* tslint:disable-next-line deprecation */
    elevation,
    boxShadow,
    height,
    margin,
    order,
    overflow,
    padding,
    position,
    transform,
    width,
    zIndex,
    ...rest
  } = props;

  React.useEffect(
    () => {
      if (round) {
        console.warn('round is deprecated and will be removed January 2022. Use borderRaduis');
      }
      if (elevation) {
        console.warn('elevation is deprecated and will be removed January 2022. Use boxShadow');
      }
    },
    [round, elevation]
  );

  return (
    <StyledBox
      {...rest}
      as={forwardedAs}
      alignContent={alignContent}
      alignItems={alignItems}
      alignSelf={alignSelf}
      backgroundColor={backgroundColor}
      border={border}
      childrenStyles={childrenStyles}
      directionProp={direction}
      displayProp={display}
      elevationProp={elevation}
      boxShadow={boxShadow}
      flexBasis={flexBasis}
      flexGrow={flexGrow}
      flexShrink={flexShrink}
      flexWrap={flexWrap}
      heightProp={height}
      justifyContent={justifyContent}
      marginProp={margin}
      orderProp={order}
      overflowProp={overflow}
      pad={padding}
      positionProp={position}
      ref={ref}
      round={round}
      borderRadius={borderRadius}
      transformProp={transform}
      widthProp={width}
      zIndex={zIndex}
    >
      {children}
    </StyledBox>
  );
});

export default Box;
